import { render, staticRenderFns } from "./UserLoad.vue?vue&type=template&id=48c6625f&scoped=true&"
import script from "./UserLoad.vue?vue&type=script&lang=js&"
export * from "./UserLoad.vue?vue&type=script&lang=js&"
import style0 from "./UserLoad.vue?vue&type=style&index=0&id=48c6625f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c6625f",
  null
  
)

export default component.exports